<p-dialog
	[(visible)]="cardSelected"
	[breakpoints]="{ '960px': '50vw', '640px': '100vw' }"
	[style]="{ width: '50vw', height: '75vh' }"
	(onHide)="cardSelectedChange.emit(undefined)"
>
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'gift-card']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ cardSelected.AcctNo }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'list-timeline']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Transactions</div>
			</ng-template>
			<p-scrollPanel>
				<p-timeline [value]="cardSelected.transactions">
					<ng-template pTemplate="content" let-rec>
						<div class="display-14">
							{{ app.moment(rec.TranDateTime).format("L LT") }} {{ rec.TranCode }}
							<span *ngIf="rec.TranCode !== 'Balance'">{{ rec.Authorize | currency }}</span>
						</div>
					</ng-template>
				</p-timeline>
				<p-scrollTop target="parent" [threshold]="0" icon="pi pi-arrow-up"></p-scrollTop>
			</p-scrollPanel>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'pen-to-square']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Adjust</div>
			</ng-template>

			<div class="p-grid">
				<div class="p-col-12 p-md-3">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#cardAdjustmentInput
							[(ngModel)]="adjustmentValue"
							prefix="$"
							inputStyleClass="text-right"
							styleClass="w-100"
						></p-inputNumber>
						<label for="cardAdjustmentInput">New Card Amount</label>
					</span>
				</div>
				<div class="p-col-12 p-md-3">code</div>
			</div>
		</p-tabPanel>
	</p-tabView>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]="true"
			(onCancelChange)="cardSelectedChange.emit(undefined)"
			(onDeleteChange)="deleteCard()"
			[cancelDisabled]=""
			[deleteDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
